

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {deepCopy} from "@/auxillary";
import {documentModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import DocumentShortDto = MdbsCore.DocumentShortDto;

@Component({})
export default class DocumentEditDialog extends Vue {
  @Prop({required: true})
  document!: DocumentShortDto;
  file: File | null = null;
  addNewVersion: boolean = false;

  valid: boolean = false;

  rules: any = {
    required: (value: any) => (value != undefined && value != null) || 'Wird benötigt',
    uniqueIdentifier: (value: string) => (this.isUpdate || !documentModule.documents.map(d => d.identifier).includes(value)) || 'Bereits vorhanden',
    uniqueTitle: (value: string) => (this.isUpdate || !documentModule.documents.map(d => d.title).includes(value)) || 'Bereits vorhanden'
  }

  get label() {
    return typeof this.addNewVersion + ": " + this.addNewVersion;
  }

  get isUpdate(): boolean {
    return this.document.id != "";
  }

  get showFileInput(): boolean {
    return !this.isUpdate || this.addNewVersion;
  }

  @Watch('document', {
    immediate: true, deep: true
  })
  onDocumentChanged(doc: DocumentShortDto | null) {
    if (!doc) {
      this.file = null;
      this.addNewVersion = false;
    }
  }

  @Watch('addNewVersion', {
    immediate: true, deep: true
  })
  onAddNewVersionChanged(value: boolean) {
    if (!value)
      this.file = null;
  }

  validateKeyPress(evt: KeyboardEvent) {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed: string = evt.key;
    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  getDocumentForSave() {
    return {
      document: deepCopy(this.document),
      file: this.file
    };
  }
}
